import { render, staticRenderFns } from "./addressCard.vue?vue&type=template&id=15667186"
import script from "./addressCard.vue?vue&type=script&lang=js"
export * from "./addressCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports